import type { Interval } from './availability';

export interface Laid<T> { item: T; start: number; end: number; lane: number; lanes: number }

/** Affianca gli impegni che si sovrappongono: ognuno prende una corsia, `lanes` e' il numero di corsie del gruppo. */
export function layoutLanes<T extends Interval>(items: readonly T[]): Laid<T>[] {
  const sorted = [...items].filter(i => i.end > i.start).sort((a, b) => a.start - b.start || a.end - b.end);
  const out: Laid<T>[] = [];
  let group: Laid<T>[] = [];
  let laneEnds: number[] = [];
  let groupEnd = -1;
  const close = () => { for (const g of group) g.lanes = laneEnds.length; out.push(...group); group = []; laneEnds = []; };
  for (const it of sorted) {
    if (group.length && it.start >= groupEnd) close();
    let lane = laneEnds.findIndex(e => e <= it.start);
    if (lane < 0) { lane = laneEnds.length; laneEnds.push(it.end); } else laneEnds[lane] = it.end;
    group.push({ item: it, start: it.start, end: it.end, lane, lanes: 1 });
    groupEnd = Math.max(groupEnd, it.end);
  }
  close();
  return out;
}
